import { StepProps, useAutoNavigate, useGraphQLQuery } from '@betterment/js-runtime';
import { Box, Button, Text } from '@betterment/samba-react';

import StepHeading from '../../AccountCreationFlow/components/StepHeading';
import { TermsAndAgreementsOption } from '../../graphql/schema';
import FullPageLoader from '../../Shared/components/FullPageLoader';
import { TermsAndAgreementsBlock } from '../../Shared/components-v2/terms-and-agreements/TermsAndAgreementsBlock';
import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { UserLevelSettingsTermsAndAgreementsDocument } from '../graphql/query.termsAndAgreements.generated';
import { useEditUserLevelSettings } from '../hooks/useEditUserLevelSettings';

export const TermsAndAgreementsStep: React.FC<StepProps> = ({ goToPreviousStep, flowState }) => {
  const navigate = useAutoNavigate();

  const selectedTermsAndAgreements: TermsAndAgreementsOption[] = [TermsAndAgreementsOption.SecuritiesLending];
  const { data } = useGraphQLQuery(UserLevelSettingsTermsAndAgreementsDocument, {
    variables: { filter: { termsAndAgreementsOptions: selectedTermsAndAgreements } },
    throwOnError: true,
  });

  const { update: updateSecuritiesLendingEnrollment } = useEditUserLevelSettings(flowState.returnToPath);

  if (!data) return <FullPageLoader />;

  const handleButtonClick = () => {
    void updateSecuritiesLendingEnrollment(true);
  };

  return (
    <WorkflowLayout
      feature="edit_user_level_settings"
      pageTitle="Terms and Agreement"
      workflowTitle={null}
      onBack={goToPreviousStep}
      onClose={() => navigate(flowState.returnToPath)}
    >
      <Box css={{ display: 'grid', gap: 'space.300' }}>
        <StepHeading>Review and confirm terms.</StepHeading>
        {data.termsAndAgreements.map(termsAndAgreement => (
          <TermsAndAgreementsBlock key={termsAndAgreement.title} termsAndAgreement={termsAndAgreement} />
        ))}
        <Text>By clicking confirm, I acknowledge that I have read and agree to the terms above.</Text>
        <Box css={{ display: 'flex' }}>
          <Button onClick={handleButtonClick} variant="solidPrimary">
            Confirm
          </Button>
        </Box>
      </Box>
    </WorkflowLayout>
  );
};
